/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Identifies the different steps in the Assistant
 */
enum Steps {
  Identification = 0,
  AdressesContacts = 1,
  Filiation = 2,
  InformationsComplementaires = 3,
  Attestation = 4,
}

export default Steps;
